import { render } from "./pairing-type.vue?vue&type=template&id=fd49aa12&lang=pug"
import script from "./pairing-type.vue?vue&type=script&lang=js"
export * from "./pairing-type.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__